import { Trophy } from "lucide-react";

export function RankingTab({ detail, nameOf }) {
  const { overall_ranking: overall, final_ranking: final, session } = detail;
  const rules = (session.ranking_rules || ["vm", "diff", "hits_for"]).map((r) => ({ vm: "V/M", diff: "Diff", hits_for: "SD", V: "V" }[r] || r)).join(" → ");
  return (
    <div className="grid lg:grid-cols-2 gap-6" data-testid="ranking-tab">
      <div className="bg-white border border-zinc-200 rounded-md overflow-hidden">
        <div className="px-4 py-3 border-b border-zinc-100 font-heading font-semibold text-sm">Classifica generale gironi <span className="text-xs text-zinc-500 font-normal">· {rules}</span></div>
        {overall.length === 0 ? <div className="p-4 text-sm text-zinc-500">Nessun girone.</div> : (
          <table className="w-full text-sm" data-testid="overall-ranking">
            <thead><tr className="bg-zinc-50 text-xs text-zinc-500"><th className="px-3 py-2 text-left">Pos</th><th className="text-left">Atleta</th><th>V</th><th>M</th><th>V/M</th><th>SD</th><th>SR</th><th>Diff</th></tr></thead>
            <tbody>
              {overall.map((r) => (
                <tr key={r.key} className="border-t border-zinc-100" data-testid={`overall-row-${r.key}`}>
                  <td className="px-3 py-1.5 font-heading font-bold">{r.place}</td>
                  <td className="truncate">{nameOf(r.key)}</td>
                  <td className="text-center font-mono">{r.V}</td><td className="text-center font-mono">{r.M}</td>
                  <td className="text-center font-mono text-xs">{r.vm.toFixed(3)}</td>
                  <td className="text-center font-mono">{r.hits_for}</td><td className="text-center font-mono">{r.hits_against}</td>
                  <td className={`text-center font-mono ${r.diff > 0 ? "text-emerald-700" : r.diff < 0 ? "text-red-600" : ""}`}>{r.diff > 0 ? "+" : ""}{r.diff}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
      <div className="bg-white border border-zinc-200 rounded-md overflow-hidden">
        <div className="px-4 py-3 border-b border-zinc-100 font-heading font-semibold text-sm flex items-center gap-2"><Trophy className="w-4 h-4 text-amber-500" />Classifica finale</div>
        {final.length === 0 ? <div className="p-4 text-sm text-zinc-500" data-testid="final-empty">Il tabellone non è ancora concluso.</div> : (
          <div className="divide-y divide-zinc-100" data-testid="final-ranking">
            {final.map((r) => (
              <div key={r.key} className="flex items-center gap-3 px-4 py-2 text-sm" data-testid={`final-row-${r.key}`}>
                <span className={`w-7 h-7 rounded-full flex items-center justify-center font-heading font-bold text-xs ${r.place === 1 ? "bg-amber-400 text-black" : r.place === 2 ? "bg-zinc-300" : r.place === 3 ? "bg-amber-200" : "bg-zinc-100 text-zinc-600"}`}>{r.place}</span>
                <span className="flex-1 truncate">{nameOf(r.key)}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
